import { createBrowserRouter } from 'react-router';
import { Sentry } from '@/lib/sentry';
import Layout from './components/Layout';
import Home from './pages/Home';
import Support from './pages/Support';
import SupportArticle from './pages/SupportArticle';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Eula from './pages/Eula';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminFeedback from './pages/AdminFeedback';
import AdminStarterKitOrders from './pages/AdminStarterKitOrders';
import ReportPage from './pages/ReportPage';
import Download from './pages/Download';
import AuthConfirm from './pages/AuthConfirm';
import AuthReset from './pages/AuthReset';
import DeepCheckSuccess from './pages/DeepCheckSuccess';
import BuyerPassSuccess from './pages/BuyerPassSuccess';
import DeepCheckReportPage from './pages/DeepCheckReportPage';
import StarterKit from './pages/StarterKit';
import StarterKitSuccess from './pages/StarterKitSuccess';
import NotFound from './pages/NotFound';
import SentryRouteError from './components/SentryRouteError';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  // Minimal auth deep-link fallbacks (no Layout)
  { path: '/auth/confirm', element: <AuthConfirm /> },
  { path: '/auth/reset', element: <AuthReset /> },
  { path: '/deep-check/success', element: <DeepCheckSuccess /> },
  { path: '/buyer-pass/success', element: <BuyerPassSuccess /> },
  { path: '/starter-kit/success', element: <StarterKitSuccess /> },
  {
    path: '/',
    element: <Layout />,
    errorElement: <SentryRouteError />,
    children: [
      { index: true, element: <Home /> },
      { path: 'download', element: <Download /> },
      { path: 'support', element: <Support /> },
      { path: 'support/:slug', element: <SupportArticle /> },
      { path: 'blog', element: <Blog /> },
      { path: 'blog/:slug', element: <BlogArticle /> },
      { path: 'privacy', element: <PrivacyPolicy /> },
      { path: 'terms', element: <TermsOfUse /> },
      { path: 'eula', element: <Eula /> },
      { path: 'admin/login', element: <AdminLogin /> },
      { path: 'admin/dashboard', element: <AdminDashboard /> },
      { path: 'admin/feedback', element: <AdminFeedback /> },
      { path: 'admin/orders', element: <AdminStarterKitOrders /> },
      { path: 'report/:shareCode', element: <ReportPage /> },
      { path: 'deep-check/report/:code', element: <DeepCheckReportPage /> },
      { path: 'starter-kit', element: <StarterKit /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  { path: '*', element: <NotFound /> },
]);
